import React from 'react';
import PropTypes from 'prop-types';

const TextArea = ({ 
  placeholder = '', 
  value = '', 
  onChange, 
  rows = 4,
  disabled = false,
  className = '',
  ...props 
}) => {
  const baseClasses = 'w-full px-3 py-3 text-sm font-inter font-normal leading-4 text-textarea-1 bg-edittext-1 border border-solid border-global-6 rounded-lg resize-vertical transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed';
  
  const textareaClasses = `${baseClasses} ${className}`.trim().replace(/\s+/g, ' ');
  
  return (
    <textarea
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      rows={rows}
      disabled={disabled}
      className={textareaClasses}
      {...props}
    />
  );
};

TextArea.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  rows: PropTypes.number,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

export default TextArea;